/**
 * Smarty — coupon / shopping assistant
 *
 * Exposes no reachable web-accessible resource, but its content script injects a
 * vendor-namespaced container into every page: `<div id="smartyContainer">`. Found with
 * `tooling/probe-interactions.js` — it appeared on a plain bait page with no user
 * action, so the marker is present whenever Smarty's content script is active.
 *
 * The id is vendor-named (`smarty…`), so this identifies Smarty specifically rather than
 * "some shopping extension". Like all behavioural signals it only fires while the
 * content script is running; a negative is therefore weaker than a resource-probe
 * negative.
 *
 * Observed on version 8.9.12.1.
 */

import { probeSelector } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'edjkecefjhobekadlkdkopkggdefpgfp';

export const smarty: ExtensionDefinition = {
  id: ID,
  name: 'Smarty',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  notes:
    'Detected behaviourally: its content script injects <div id="smartyContainer"> into ' +
    'the page. No reachable web-accessible resource, so this is the only signal.',
  signals: [
    {
      id: 'dom-smarty-container',
      kind: 'dom',
      description:
        'Look for #smartyContainer — the vendor-namespaced container Smarty injects into ' +
        'every page while its content script is active.',
      weight: 1,
      run: () => probeSelector('#smartyContainer', { timeoutMs: 2000 }),
    },
  ],
};
